import api from './api';

export const createSale = (saleData) => api.post('/sales', saleData);
export const getSales = (params) => api.get('/sales', { params });
export const getSale = (id) => api.get(`/sales/${id}`);
export const voidSale = (id, data) => api.put(`/sales/${id}/void`, data);
export const refundSale = (id, data) => api.post(`/sales/${id}/refund`, data);
export const getTodaySales = () => api.get('/sales/today');
export const getCurrentShift = () => api.get('/sales/shift/current');
export const printReceipt = (id) => api.get(`/sales/${id}/receipt/print`, { responseType: 'blob' });
export const emailReceipt = (id, email) => api.post(`/sales/${id}/receipt/email`, { email });
export const recordPayment = (saleId, paymentData) => api.post(`/sales/${saleId}/payment`, paymentData);
